var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 53,
    viewBox: "0 0 90 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cloud",
    d: "M68.8158 12.085C57.3365 12.085 48.0342 21.1677 48.0342 32.3721C48.0342 35.4575 48.7668 38.5013 50.1559 41.2677L48.0342 52.6523H69.1751C80.5024 52.4443 89.5835 43.4309 89.5905 32.3721C89.5905 21.1677 80.2881 12.085 68.8158 12.085Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cloud",
    d: "M41.2951 0C26.4018 0 14.3281 11.7868 14.3281 26.3262C14.3281 34.0638 17.8182 41.4133 23.8654 46.4123L20.0159 52.6523H48.8835C52.339 51.432 55.4766 49.1995 57.9923 46.9947C60.0725 45.393 61.9039 43.5002 63.4106 41.3786C63.4382 41.3509 63.4797 41.3023 63.5004 41.2677C66.6035 36.8719 68.269 31.6649 68.269 26.3262C68.269 11.7868 56.1954 0 41.2951 0Z",
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cloud",
    d: "M17.2449 19.5596C12.7458 19.5596 8.43331 21.2999 5.25422 24.406C2.07512 27.5053 0.285156 31.7208 0.285156 36.1096C0.298978 44.9012 7.34136 52.1466 16.3327 52.6181V52.6597H25.2479C28.427 50.2884 30.6317 46.8633 31.9724 44.2841C32.47 43.4313 32.8847 42.53 33.2164 41.6009C33.251 41.5177 33.327 41.3513 33.3546 41.275H33.3408C33.9006 39.6041 34.1909 37.8638 34.1978 36.1166C34.1978 26.9783 26.6094 19.5665 17.2449 19.5665",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLoader);
export default __webpack_public_path__ + "static/media/cloud-loader.7cb018660294d848f4ac6e8d0eb9b521.svg";
export { ForwardRef as ReactComponent };